<template>
  <div class="u-dropdown">
    <Dropdown
      :trigger="trigger"
      :placement="placement"
      :visible="visible"
      :transfer="transfer"
      :transfer-class-name="transferClassName"
      :stop-propagation="stopPropagation"
      @on-click="onClick"
      @on-visible-change="onVisibleChange"
      @on-clickoutside="onClickoutside"
    >
      <!--<dropdown-slot name="list"></dropdown-slot>-->
      <slot></slot>
      <div slot="list">
        <slot name="list"></slot>
      </div>
      <!--<slot name="u-list" slot="list"></slot>-->
    </Dropdown>

  </div>
</template>

<script>
import "@/styles/component/uDropdown.less";
import dropdownSlot from "./slot";
export default {
  name: "uDropdown",
  provide() {
    return {
      root: this
    };
  },
  mounted() {
    console.log(this.$slots);
  },
  props: {
    trigger: {
      type: String
    },
    placement: {
      type: String
    },
    visible: {
      type: Boolean
    },
    transfer: {
      type: Boolean
    },
    transferClassName: {
      type: String
    },
    stopPropagation: {
      type: Boolean
    }
  },
  methods: {
    onClick(name) {
      //点击菜单项时触发	 返回DropdownItem 的 name 值
      this.$emit("on-click", name);
    },
    onVisibleChange(visible) {
      //菜单显示状态改变时调用	 返回visible
      this.$emit("on-visible-change", visible);
    },
    onClickoutside(event) {
      this.$emit("on-clickoutside", event);
    }
  },
  components: {
    dropdownSlot
  }
};
</script>
